import { render } from "./TvmServiceTypes.vue?vue&type=template&id=b929556c&scoped=true"
import script from "./TvmServiceTypes.js?vue&type=script&lang=js&external"
export * from "./TvmServiceTypes.js?vue&type=script&lang=js&external"

import "./TvmServiceTypes.vue?vue&type=style&index=0&id=b929556c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b929556c"]])

export default __exports__